var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _rect, _circle, _circle2, _path9, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.21 40C119.85 33.2931 125.631 20.6882 125 14C124.863 12.5535 127 12.2993 128 14C132.418 21.5124 130.717 36.0672 130.154 40H133V52H107V40H112.21ZM57.521 13.7408C57.521 21.2733 62.4918 33.445 70.2618 40H75V52H49V40H52.2251C51.6299 36.4414 49.5293 21.6012 54.4337 14.1009C55.3353 12.7219 57.521 12.6807 57.521 13.7408Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 12,
    width: 84,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.21 40C119.85 33.2931 125.631 20.6882 125 14C124.863 12.5535 127 12.2993 128 14C132.418 21.5124 130.717 36.0672 130.154 40H133V52H107V40H112.21ZM57.521 13.7408C57.521 21.2733 62.4918 33.445 70.2618 40H75V52H49V40H52.2251C51.6299 36.4414 49.5293 21.6012 54.4337 14.1009C55.3353 12.7219 57.521 12.6807 57.521 13.7408Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#E57373"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 40,
    width: 100,
    height: 12,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4558 13H72.5689V40H61.8201C54.3712 32.1499 56.4558 13 56.4558 13Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.82 13H133.569V40H122.82C128.571 32.1946 125.82 13 125.82 13Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4878 61.4723C25 68.3175 25 77.2783 25 95.2V123.586H29V148C29 156.837 36.1634 164 45 164H135C143.837 164 151 156.837 151 148V123.586H155V95.2C155 77.2783 155 68.3175 151.512 61.4723C148.444 55.4511 143.549 50.5557 137.528 47.4878C130.683 44 121.722 44 103.8 44H76.2C58.2783 44 49.3175 44 42.4723 47.4878C36.4511 50.5557 31.5557 55.4511 28.4878 61.4723Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4878 61.4723C25 68.3175 25 77.2783 25 95.2V123.586H29V148C29 156.837 36.1634 164 45 164H135C143.837 164 151 156.837 151 148V123.586H155V95.2C155 77.2783 155 68.3175 151.512 61.4723C148.444 55.4511 143.549 50.5557 137.528 47.4878C130.683 44 121.722 44 103.8 44H76.2C58.2783 44 49.3175 44 42.4723 47.4878C36.4511 50.5557 31.5557 55.4511 28.4878 61.4723Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 44,
    width: 134,
    height: 120,
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 124,
    width: 122,
    height: 40,
    fill: "black",
    fillOpacity: 0.8
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 134.222C70 145.785 76.4741 152 90 152C103.518 152 110 145.661 110 134.222C110 133.496 109.174 132 107 132C91.2707 132 81.1917 132 73 132C70.949 132 70 133.385 70 134.222Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 132,
    width: 40,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 134.222C70 145.785 76.4741 152 90 152C103.518 152 110 145.661 110 134.222C110 133.496 109.174 132 107 132C91.2707 132 81.1917 132 73 132C70.949 132 70 133.385 70 134.222Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 126,
    width: 16,
    height: 14,
    rx: 2,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 24,
    fill: "white",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 20,
    fill: "black",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.572 91.8153C102.874 92.2779 103.494 92.4082 103.956 92.1064C104.419 91.8046 104.549 91.185 104.247 90.7225L102.572 91.8153ZM99.5814 85.9555C99.1254 85.6438 98.5032 85.7608 98.1915 86.2168C97.8799 86.6728 97.9969 87.295 98.4529 87.6067L99.5814 85.9555ZM94.3567 85.6422C94.8853 85.8024 95.4436 85.5037 95.6037 84.9752C95.7639 84.4466 95.4652 83.8883 94.9367 83.7282L94.3567 85.6422ZM83.7205 84.1977C83.2073 84.4018 82.9567 84.9833 83.1608 85.4964C83.3649 86.0096 83.9464 86.2602 84.4596 86.0561L83.7205 84.1977ZM79.7602 89.0388C80.1637 88.6617 80.185 88.0289 79.8079 87.6254C79.4308 87.2219 78.798 87.2005 78.3945 87.5776L79.7602 89.0388ZM74.4566 93.1052C74.2324 93.6099 74.4598 94.2008 74.9645 94.425C75.4693 94.6492 76.0602 94.4218 76.2844 93.9171L74.4566 93.1052ZM104.247 90.7225C103.021 88.8427 101.433 87.2208 99.5814 85.9555L98.4529 87.6067C100.087 88.7238 101.49 90.1559 102.572 91.8153L104.247 90.7225ZM94.9367 83.7282C93.3731 83.2544 91.7154 83 90 83V85C91.5167 85 92.9792 85.2248 94.3567 85.6422L94.9367 83.7282ZM90 83C87.7839 83 85.6645 83.4246 83.7205 84.1977L84.4596 86.0561C86.1723 85.375 88.0411 85 90 85V83ZM78.3945 87.5776C76.7377 89.1261 75.3904 91.0029 74.4566 93.1052L76.2844 93.9171C77.1078 92.0633 78.2967 90.4066 79.7602 89.0388L78.3945 87.5776Z",
    fill: "white",
    fillOpacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 10,
    fill: "#C6080C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 4,
    fill: "#EE9337"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 1,
    fill: "#F5F94F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot11);
export default __webpack_public_path__ + "static/media/bot-11.2c2d29eb62fe6847aff42428d5adf0cc.svg";
export { ForwardRef as ReactComponent };